<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title"></div>
                <div class="tools">
                    <button type="button" class="btn btn-primary btn-sm" (click)="onSave()" [disabled]="downloadForm.invalid || loading">
                        <i class="bi bi-save"></i> {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <div class="card-body-title">{{ 'INTEGRATION.OPRIONS_FOR_IMPORT_PEACE_LIST' | translate }}</div>

                <form class="form" #f="ngForm" [formGroup]="downloadForm" autocomplete="off">

                    <div class="row">

                        <div class="col-12 form-group">
                            <label for="url" class="label"><span class="star">*</span> URL</label>
                            <input type="text" class="form-control" id="url" formControlName="url">
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.url">
                                    <div class="text-error" *ngIf="validation('url', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-6 form-group">
                            <label for="login" class="label"> {{ 'MENU_AUTH_USER.LOGIN' | translate }}</label>
                            <input type="text" class="form-control" id="login" formControlName="login">
                        </div>

                        <div class="col-6 form-group">
                            <label for="password" class="label"> {{ 'USERS.USERS_EDITOR.PASS' | translate }}</label>
                            <input type="text" class="form-control" id="password" formControlName="password">
                        </div>

                    </div>

                </form>

            </div>

        </div>

    </div>
</div>